<script>
  import { link } from "svelte-routing";
  import { panelController } from "../../../../stores/service";
  import ViewEdit from "../panels/edit_view.svelte";

  document.title = "Ratingg | Configurar dashboards";

  const initial = Number(new URLSearchParams(window.location.search).get("d"));

  $: dashboards = $panelController.service.listRatinggs;
  let active = Number.isInteger(initial) && initial >= 0 ? initial : 0;
  $: if (active >= dashboards.length) active = 0;
</script>

<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous" />
  <link
    href="https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700&family=DM+Sans:wght@400;500;600;700&display=swap"
    rel="stylesheet"
  />
</svelte:head>

<div class="cfg-page">
  <a use:link href="/MainAnalytics/menu" class="back">← Estadísticas</a>
  <h1>Configurar dashboards</h1>
  <p class="lead">Nombre, acceso y preguntas de cada encuesta.</p>

  <div class="tabs" role="tablist" aria-label="Dashboards">
    {#each dashboards as d, i}
      <button
        type="button"
        role="tab"
        class="tab"
        class:is-active={active === i}
        aria-selected={active === i}
        on:click={() => (active = i)}>{d.config.name}</button
      >
    {/each}
  </div>

  {#key active}
    <ViewEdit panelist={{ index: active, service: $panelController.service }} />
  {/key}
</div>

<style>
  .cfg-page {
    --olive-900: #2c3320;
    --olive-100: #e4ebce;
    --cream: #fbf6ea;
    --ink-soft: #57543f;
    --ink-faint: #83805f;
    font-family: "DM Sans", ui-sans-serif, system-ui, sans-serif;
    max-width: 860px;
    margin: 0 auto;
  }

  .back {
    display: inline-block;
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--ink-soft);
    margin-bottom: 0.5rem;
  }

  h1 {
    font-family: "Fraunces", ui-serif, Georgia, serif;
    font-weight: 600;
    font-size: 1.4rem;
    color: var(--olive-900);
    margin: 0;
  }

  .lead {
    margin: 0.15rem 0 0.9rem;
    font-size: 0.85rem;
    color: var(--ink-faint);
  }

  .tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0.25rem;
    padding: 3px;
    margin-bottom: 1rem;
    background: var(--olive-100);
    border-radius: 10px;
    width: fit-content;
    max-width: 100%;
  }

  .tab {
    border: 0;
    background: transparent;
    border-radius: 8px;
    padding: 0.4rem 0.9rem;
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--ink-faint);
    text-align: left;
  }

  .tab.is-active {
    background: var(--cream);
    color: var(--olive-900);
    box-shadow: 0 1px 3px rgba(44, 51, 32, 0.15);
  }
</style>
